/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FindAllSourceTags200ResponseDataInner } from './FindAllSourceTags200ResponseDataInner';
import {
    FindAllSourceTags200ResponseDataInnerFromJSON,
    FindAllSourceTags200ResponseDataInnerFromJSONTyped,
    FindAllSourceTags200ResponseDataInnerToJSON,
} from './FindAllSourceTags200ResponseDataInner';

/**
 * 
 * @export
 * @interface FindAllSourceTags200Response
 */
export interface FindAllSourceTags200Response {
    /**
     * 
     * @type {Array<FindAllSourceTags200ResponseDataInner>}
     * @memberof FindAllSourceTags200Response
     */
    data?: Array<FindAllSourceTags200ResponseDataInner>;
}

/**
 * Check if a given object implements the FindAllSourceTags200Response interface.
 */
export function instanceOfFindAllSourceTags200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FindAllSourceTags200ResponseFromJSON(json: any): FindAllSourceTags200Response {
    return FindAllSourceTags200ResponseFromJSONTyped(json, false);
}

export function FindAllSourceTags200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllSourceTags200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(FindAllSourceTags200ResponseDataInnerFromJSON)),
    };
}

export function FindAllSourceTags200ResponseToJSON(value?: FindAllSourceTags200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(FindAllSourceTags200ResponseDataInnerToJSON)),
    };
}

